<template>
  <div
    class="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-lg bg-gray-200 border-0"
  >
    <div class="rounded-t bg-white mb-0 px-6 py-6">
      <div class="text-center flex justify-between">
        <h6 class="text-dark text-lg">Buy or sell your tokens instantly</h6>

        <p>
          <a href="#">
            <span class="fas fa-exchange-alt text-base text-center px-5">
            </span>
            BUY BGBB</a
          >
        </p>
      </div>
    </div>
    <div class="flex-auto px-4 lg:px-10 py-10 pt-0">
      <div class="flex flex-wrap">
        <div class="w-full lg:w-12/12 px-4">
          <div class="relative w-full mb-3">
            <div class="text-center mt-8 text-2xl">
              <h5>Input Currency</h5>

              <br />

              <!-- TABS -->

              <ul class="flex mb-0 list-none flex-wrap pt-3 pb-4 flex-row">
                <li class="-mb-px mr-2 last:mr-0 flex-auto text-center">
                  <a
                    class="text-base font-bold uppercase px-5 py-3 shadow-lg rounded-full block leading-normal cursor-pointer"
                    v-on:click="toggleTabs(1)"
                    v-bind:class="{
                      'text-emerald-600 bg-white': openTab !== 1,
                      'text-white bg-bgbb-y': openTab === 1,
                    }"
                  >
                    ADA
                  </a>
                </li>
                <li class="-mb-px mr-2 last:mr-0 flex-auto text-center">
                  <a
                    class="text-base font-bold uppercase px-5 py-3 shadow-lg rounded-full block leading-normal cursor-pointer"
                    v-on:click="toggleTabs(2)"
                    v-bind:class="{
                      'text-emerald-600 bg-white': openTab !== 2,
                      'text-white bg-bgbb-y': openTab === 2,
                    }"
                  >
                    CARDS
                  </a>
                </li>
                <li class="-mb-px mr-2 last:mr-0 flex-auto text-center">
                  <a
                    class="text-base font-bold uppercase px-5 py-3 shadow-lg rounded-full block leading-normal cursor-pointer"
                    v-on:click="toggleTabs(3)"
                    v-bind:class="{
                      'text-emerald-600 bg-white': openTab !== 3,
                      'text-white bg-bgbb-y': openTab === 3,
                    }"
                  >
                    AgeUSD
                  </a>
                </li>
                <!-- <li class="-mb-px mr-2 last:mr-0 flex-auto text-center">
                  <a
                    class="text-base font-bold uppercase px-5 py-3 shadow-lg rounded-full block leading-normal cursor-pointer"
                    v-on:click="toggleTabs(4)"
                    v-bind:class="{
                      'text-emerald-600 bg-white': openTab !== 4,
                      'text-white bg-bgbb-y': openTab === 4,
                    }"
                  >
                    CARDS
                  </a>
                </li> -->
              </ul>
              <div
                class="relative flex flex-col min-w-0 break-words w-full mb-6"
              >
                <div class="px-4 py-5 flex-auto">
                  <div class="tab-content tab-space">
                    <div
                      v-bind:class="{
                        hidden: openTab !== 1,
                        block: openTab === 1,
                      }"
                    >
                      <!-- ADA TAB -->

                      <!-- SWAP ADA-BGBB PREVIEW -->
                      <form>
                        <div class="flex flex-wrap">
                          <div class="w-full lg:w-12/12">
                            <div class="relative w-full mb-3">
                              <div class="text-center mt-8 text-2xl">
                                <h5>Swap Preview</h5>
                              </div>

                              <div
                                class="relative flex w-full flex-wrap items-stretch my-4"
                              >
                                <span
                                  class="z-10 h-full leading-snug font-normal absolute text-center text-blueGray-300 absolute bg-transparent rounded text-lg items-center justify-center w-8 pl-3 py-10"
                                >
                                  <i class="fas fa-wallet"></i>
                                </span>
                                <input
                                  type="number"
                                  placeholder="0.000 ADA"
                                  class="px-3 py-10 placeholder-blueGray-300 text-dark relative bg-white rounded text-base shadow outline-none focus:outline-none focus:shadow-outline w-full pl-10"
                                />
                              </div>
                              <div class="text-center my-6 text-lg">
                                <span
                                  class="fas fa-exchange-alt text-3xl text-center flipped2"
                                ></span>
                              </div>
                              <div
                                class="relative flex w-full flex-wrap items-stretch my-4"
                              >
                                <span
                                  class="z-10 h-full leading-snug font-normal absolute text-center text-blueGray-300 absolute bg-transparent rounded text-lg items-center justify-center w-8 pl-3 py-10"
                                >
                                  <i class="fas fa-wallet"></i>
                                </span>
                                <input
                                  type="number"
                                  placeholder="0.000 BGBB"
                                  class="px-3 py-10 placeholder-blueGray-300 text-blueGray-600 relative bg-white bg-white rounded text-base shadow outline-none focus:outline-none focus:shadow-outline w-full pl-10"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </form>
                      <div
                        class="flex flex-wrap text-center justify-center mt-8"
                      >
                        <a
                          href="#"
                          target="_self"
                          class="shadow-xl font-semibold text-white px-6 py-4 rounded outline-none focus:outline-none mr-1 mb-1 bg-dark-bgbb100 uppercase text-lg tracking-wide container"
                        >
                          Swap ADA
                          <span
                            class="fas fa-exchange-alt text-base text-center"
                          ></span>
                          BGBB
                        </a>
                      </div>
                      <!-- SWAP ADA-BGBB PREVIEW END -->
                      <!-- ADA TAB END -->
                    </div>
                    <div
                      v-bind:class="{
                        hidden: openTab !== 2,
                        block: openTab === 2,
                      }"
                    >
                      <!-- SADA TAB -->

                      <form>
                        <div class="flex flex-wrap">
                          <div class="w-full lg:w-12/12">
                            <div class="relative w-full mb-3">
                              <div class="text-center mt-8 text-2xl">
                                <h5>Swap Preview</h5>
                              </div>

                              <!-- SWAP ADA-BGBB PREVIEW -->

                              <div
                                class="relative flex w-full flex-wrap items-stretch my-4"
                              >
                                <span
                                  class="z-10 h-full leading-snug font-normal absolute text-center text-blueGray-300 absolute bg-transparent rounded text-lg items-center justify-center w-8 pl-3 py-10"
                                >
                                  <i class="fas fa-wallet"></i>
                                </span>
                                <input
                                  type="text"
                                  placeholder="0.000 CARDS"
                                  class="px-3 py-10 placeholder-blueGray-300 text-dark relative bg-white rounded text-base shadow outline-none focus:outline-none focus:shadow-outline w-full pl-10"
                                />
                              </div>
                              <div class="text-center my-6 text-lg">
                                <span
                                  class="fas fa-exchange-alt text-3xl text-center flipped2"
                                ></span>
                              </div>
                              <div
                                class="relative flex w-full flex-wrap items-stretch my-4"
                              >
                                <span
                                  class="z-10 h-full leading-snug font-normal absolute text-center text-blueGray-300 absolute bg-transparent rounded text-lg items-center justify-center w-8 pl-3 py-10"
                                >
                                  <i class="fas fa-wallet"></i>
                                </span>
                                <input
                                  type="text"
                                  placeholder="0.000 BGBB"
                                  class="px-3 py-10 placeholder-blueGray-300 text-blueGray-600 relative bg-white bg-white rounded text-base shadow outline-none focus:outline-none focus:shadow-outline w-full pl-10"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </form>
                      <div
                        class="flex flex-wrap text-center justify-center mt-8"
                      >
                        <a
                          href="#"
                          target="_self"
                          class="shadow-xl font-semibold text-white px-6 py-4 rounded outline-none focus:outline-none mr-1 mb-1 bg-dark-bgbb100 uppercase text-lg tracking-wide container"
                        >
                          Swap CARDS  
                          <span
                            class="fas fa-exchange-alt text-base text-center"
                          ></span>
                          BGBB
                        </a>
                      </div>
                    </div>
                    <!-- SWAP ADA-BGBB PREVIEW END -->

                    <!-- SADA SWAP TAB END -->

                    <div
                      v-bind:class="{
                        hidden: openTab !== 3,
                        block: openTab === 3,
                      }"
                    >
                      <!-- SWAP BUSD -BGBB  -->

                      <!-- SWAP ADA-BGBB PREVIEW -->
                      <form>
                        <div class="flex flex-wrap">
                          <div class="w-full lg:w-12/12">
                            <div class="relative w-full mb-3">
                              <div class="text-center mt-8 text-2xl">
                                <h5>Swap Preview</h5>
                              </div>

                              <div
                                class="relative flex w-full flex-wrap items-stretch my-4"
                              >
                                <span
                                  class="z-10 h-full leading-snug font-normal absolute text-center text-blueGray-300 absolute bg-transparent rounded text-lg items-center justify-center w-8 pl-3 py-10"
                                >
                                  <i class="fas fa-wallet"></i>
                                </span>
                                <input
                                  type="text"
                                  placeholder="0.000 AgeUSD"
                                  class="px-3 py-10 placeholder-blueGray-300 text-dark relative bg-white rounded text-base shadow outline-none focus:outline-none focus:shadow-outline w-full pl-10"
                                />
                              </div>
                              <div class="text-center my-6 text-lg">
                                <span
                                  class="fas fa-exchange-alt text-3xl text-center flipped2"
                                ></span>
                              </div>
                              <div
                                class="relative flex w-full flex-wrap items-stretch my-4"
                              >
                                <span
                                  class="z-10 h-full leading-snug font-normal absolute text-center text-blueGray-300 absolute bg-transparent rounded text-lg items-center justify-center w-8 pl-3 py-10"
                                >
                                  <i class="fas fa-wallet"></i>
                                </span>
                                <input
                                  type="text"
                                  placeholder="0.000 BGBB"
                                  class="px-3 py-10 placeholder-blueGray-300 text-blueGray-600 relative bg-white bg-white rounded text-base shadow outline-none focus:outline-none focus:shadow-outline w-full pl-10"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </form>
                      <div
                        class="flex flex-wrap text-center justify-center mt-8"
                      >
                        <a
                          href="#"
                          target="_self"
                          class="shadow-xl font-semibold text-white px-6 py-4 rounded outline-none focus:outline-none mr-1 mb-1 bg-dark-bgbb100 uppercase text-lg tracking-wide container"
                        >
                          Swap AgeUSD
                          <span
                            class="fas fa-exchange-alt text-base text-center"
                          ></span>
                          BGBB
                        </a>
                      </div>
                      <!-- SWAP ADA-BGBB PREVIEW END -->

                      <!-- SWAP BUSD - BGBB END -->
                    </div>

                  
                  

                    <!-- CAKE END -->
                  </div>
                </div>
              </div>
            </div>
            <!-- </div> -->
            <!-- </div> -->

            <!-- TABS -->

            <br />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
//  import bnb from "@/assets/img/bnb.svg";

export default {
  name: "emerald-tabs",
  data() {
    return {
      openTab: 1,
    };
  },
  methods: {
    toggleTabs: function (tabNumber) {
      this.openTab = tabNumber;
    },
  },
};
</script>
